export * from './registration';
export * from './login';
export * from './account';

export const PATH_ERROR_404 = '/404';
export const PATH_ERROR_500 = '/500';
export const PATH_LOGOUT = '/logout';
export const PATH_PAYMENT = '/payment';
export const PATH_SUBSCRIPTION = '/subscription';
